import React from 'react'
import AppFrame from '../AppFrame'
import { useQuery } from "@apollo/client"
import { get, map } from 'lodash'

import { QUERY_SERVICE_DATA } from '../data/services/graphqlQueries'
import PageHeader from '../components/PageHeader'
import BackButton from '../components/BackButton'
import Loading from '../components/Loading'

export default ({globalData, clinic, slug}) => {
  const { loading, error, data } = useQuery(QUERY_SERVICE_DATA, {
    notifyOnNetworkStatusChange: true,
    variables: { clinic, slug },
  })

  if (loading) return <Loading />

  if (data.services.length === 0) return <div>service not found</div>

  const serviceData = get(data, 'services[0]')

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto py-8 px-4">
      <PageHeader title={serviceData.title} />
      <div className="ecs-html mb-4" dangerouslySetInnerHTML={{__html: serviceData.fullDescription.html}} />
      <div className="ecs-brands mb-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-[600px] lg:max-w-[800px] mx-auto">
        {
          map(serviceData.brands, (b, ndx) => {
            const key = `brand-${ndx}`
            if (!b.enabled) return <React.Fragment key={key}></React.Fragment>

            if (!b.image) {
              return <div className="" key={key}>
                {b.title}
              </div>
            }

            const image = <img src={b.image.url} alt={b.title} />
            return <div className="" key={key}>
              {
                b.url !== '' &&
                <a href={b.url} target="_blank">{image}</a>
              }
              {
                (b.url == '') && image
              }
              
            </div>
          })
        }
      </div>
      <BackButton url={clinic ? `/${clinic}/services` : '/services'} />
      </div>
    </AppFrame>
  )
}